'use client';

import { T } from '@flipster/i18n';
import { useRouter } from '@flipster/i18n/routing';
import { Styles, css } from '@flipster/styled-system/css';
import { center, vstack } from '@flipster/styled-system/patterns';

import { VipButton } from '../../shared/vip-button';
import leftCoins from './assets/left.webp';
import rightCoins from './assets/right.webp';

interface Props {
  css?: Styles;
}

export const ProofOfReservesSection = ({ css: cssProps }: Props) => {
  const router = useRouter();

  return (
    <section
      className={css(
        center.raw({
          flexDir: 'column',
          py: { base: 40, tablet: 96 },
          px: 16,
          overflow: 'hidden',
        }),
        cssProps,
      )}
    >
      <img
        src={leftCoins.src}
        alt=''
        className={css({
          pos: 'absolute',
          w: 280,
          left: 0,
          bottom: 0,
          display: { smallDesktopDown: 'none' },
        })}
      />
      <img
        src={rightCoins.src}
        alt=''
        className={css({
          pos: 'absolute',
          w: 280,
          right: 0,
          bottom: 0,
          display: { smallDesktopDown: 'none' },
        })}
      />

      <div className={vstack({ gap: 16, textAlign: 'center', zIndex: 1, w: '100%' })}>
        <p className={css({ textStyle: 'Title/S', color: 'rgba(255, 208, 132)' })}>
          <T id='VIP.r260304.Hundred_proof_of_reserves' />
        </p>
        <h2 className={css({ textStyle: 'Display/XL', color: 'content.default.level-5' })}>
          <T
            id='VIP.r260303.Fully_transparent_1_1_reserves_ratio'
            values={{
              vip: (chunks: React.ReactNode) => (
                <span
                  className={css({
                    background: 'linear-gradient(90deg, #FFD084 0%, #FFFCEE 100%)',
                    backgroundClip: 'text',
                    color: 'transparent',
                  })}
                >
                  {chunks}
                </span>
              ),
            }}
          />
        </h2>
        <p
          className={css({
            textStyle: 'Text/L/Regular',
            color: 'content.default.level-2',
          })}
        >
          <T id='VIP.r260303.Our_proof_of_reserves_por_ensures_that_all_customer_deposits_are_fully_backed_ve' />
        </p>
        <VipButton
          hierarchy='secondary'
          label={<T id='VIP.r260303.View_proof_of_reserves_button' />}
          onClick={() => router.push('/support/proof-of-reserves')}
          css={{ mt: 8, minW: 280, tabletDown: { w: '100%' } }}
        />
      </div>
    </section>
  );
};
